// @flow
import React, { Component } from 'react';
import {
  Text, RadioGroup, Radio,
} from 'informed';

import ContentBox from '../ContentBox.jsx';
import DateText from '../DateText.jsx';
import { Label } from '../Typography.jsx';
import ValidateText from '../ValidateText.jsx';

type Props = {
  editing: boolean,
}

class BasicInfoSection extends Component<Props> {
  render() {
    return (
      <ContentBox title="General Information">
        <table>
          <tbody>
            <tr>
              <td><Label>First Name:</Label></td>
              <td>
                <ValidateText
                  field='firstName'
                  initialValue=''
                  regex={/.*\S.*/}
                  errorText='Name must be nonempty'
                  disabled={!this.props.editing} />
              </td>
            </tr>
            <tr>
              <td><Label>Siswati Name:</Label></td>
              <td><Text field='siswatiName' disabled={!this.props.editing} /></td>
            </tr>
            <tr>
              <td><Label>Surname:</Label></td>
              <td><Text field='surname' disabled={!this.props.editing} /></td>
            </tr>
            <tr>
              <td><Label>Sex:</Label></td>
              <td>
                <RadioGroup field='sex'>
                  <Radio value='M' disabled={!this.props.editing} /> M
                  {'   '}
                  <Radio value='F' disabled={!this.props.editing} /> F
                </RadioGroup>
              </td>
            </tr>
            <tr>
              <td><Label>Date of Birth:</Label></td>
              <td><DateText field='dob' item={{}} initEmpty disabled={!this.props.editing} /></td>
            </tr>
            <tr>
              <td><Label>Date Arrived at PC:</Label></td>
              <td><DateText field='dateArrived' item={{}} disabled={!this.props.editing} initEmpty /></td>
            </tr>
          </tbody>
        </table>
      </ContentBox>
    );
  }
}

export default BasicInfoSection;



// WEBPACK FOOTER //
// ./client/src/components/addPatientPage/BasicInfoSection.jsx